import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Image, StyleSheet, Text, View } from 'react-native';

import { EmptyBadgePng } from '../../../assets/achievements';
import { ACHIEVEMENTS_FONT, achievementsColors } from './achievementsTheme';
import { achievementText } from './achievementsViewModel';

const BADGE = { width: 48.497, height: 56 };

type Props = {
	scale: number;
};

export const AchievementsEmptyState = ({ scale }: Props) => {
	const styles = useMemo(() => createStyles(scale), [scale]);
	const { t } = useTranslation();

	return (
		<View style={styles.root}>
			<View style={styles.badgeSlot}>
				<Image source={EmptyBadgePng} style={styles.badge} resizeMode='contain' />
			</View>
			<Text style={styles.title}>{achievementText(t, 'T_SITE_ACHIEVEMENTS_EMPTY_TITLE')}</Text>
			<Text style={styles.body}>{achievementText(t, 'T_SITE_ACHIEVEMENTS_EMPTY_BODY')}</Text>
		</View>
	);
};

const createStyles = (scale: number) =>
	StyleSheet.create({
		root: {
			alignItems: 'center',
			gap: 8 * scale,
			paddingVertical: 40 * scale,
		},
		badgeSlot: {
			width: 56 * scale,
			height: 56 * scale,
			alignItems: 'center',
			justifyContent: 'center',
		},
		badge: {
			width: BADGE.width * scale,
			height: BADGE.height * scale,
		},
		title: {
			width: '100%',
			color: achievementsColors.primary,
			fontFamily: ACHIEVEMENTS_FONT,
			fontSize: 14 * scale,
			fontWeight: '700',
			textAlign: 'center',
		},
		body: {
			width: '100%',
			color: achievementsColors.secondary,
			fontFamily: ACHIEVEMENTS_FONT,
			fontSize: 12 * scale,
			fontWeight: '600',
			lineHeight: 12 * 1.4 * scale,
			textAlign: 'center',
		},
	});

export default AchievementsEmptyState;
